import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import { close } from '#utilities/js/lightboxes/menus/dropdown.js'
import { globals } from '#utilities/js/ea/ea.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    li
  ) => {
    const { dataset, ownerDocument } = li
    const { value } = dataset
    const form = one('form[name="send_valid"]', ownerDocument)

    if (form) {
      let target = 'divmodal'

      if ((value === 'attach_camera') || (value === 'attach_draw')) {
        target = ''
      }

      globals.ea_mail_submit(form, target, value, 1)
    }
    close()
  }
})

export default quickAttach => {
  for (const li of all('li', quickAttach)) {
    onClick.listen(li)
  }
}
